/**
 * Animate Section Component
 * Automatically triggers fade-in and slide-up animation when elements with
 * class "animate-section" enter the viewport
 */

(function() {
  'use strict';

  class AnimateSection {
    constructor() {
      this.animateClass = 'animate-section';
      this.activeClass = 'animate-active';
      this.showClass = 'animate-show';
      this.observer = null;
      this.lastScrollY = window.pageYOffset || document.documentElement.scrollTop;
      this.isScrollingDown = true;
      this.init();
    }

    init() {
      if (!('IntersectionObserver' in window)) {
        console.warn('Intersection Observer not supported. Showing elements without animation.');
        this.fallback();
        return;
      }

      this.setupScrollListener();
      this.setupObserver();
      this.observeElements();
    }

    setupScrollListener() {
      let ticking = false;

      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(() => {
            const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
            this.isScrollingDown = currentScrollY > this.lastScrollY;
            this.lastScrollY = currentScrollY;
            ticking = false;
          });
          ticking = true;
        }
      }, { passive: true });
    }

    setupObserver() {
      const options = {
        root: null,
        rootMargin: '0px 0px -50px 0px',
        threshold: 0.1
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            if (this.isScrollingDown) {
              entry.target.classList.remove(this.showClass);
              entry.target.classList.add(this.activeClass);
            } else {
              entry.target.classList.remove(this.activeClass);
              entry.target.classList.add(this.showClass);
            }
          } else {
            entry.target.classList.remove(this.activeClass);
            entry.target.classList.remove(this.showClass);
          }
        });
      }, options);
    }

    observeElements() {
      const elements = document.querySelectorAll(`.${this.animateClass}`);
      elements.forEach(element => {
        this.observer.observe(element);
      });
    }

    fallback() {
      const elements = document.querySelectorAll(`.${this.animateClass}`);
      elements.forEach(element => {
        element.classList.add(this.activeClass);
      });
    }

    refresh() {
      if (this.observer) {
        this.observeElements();
      }
    }

    destroy() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }

  function initAnimateSection() {
    window.animateSectionInstance = new AnimateSection();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimateSection);
  } else {
    initAnimateSection();
  }

  document.addEventListener('shopify:section:load', function() {
    if (window.animateSectionInstance) {
      setTimeout(function() {
        window.animateSectionInstance.refresh();
      }, 100);
    }
  });

  window.AnimateSection = AnimateSection;
})();
